// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__2h0Pv","fullScreen":"style_fullScreen__Cwnv5","hidden":"style_hidden__1qzH-"};